export enum UserIdp {
    GravityZone = 1,
    Auth0 = 2,
    Local = 3,
}
